import { render, staticRenderFns } from "./outline.vue?vue&type=template&id=20bc71ea"
import script from "./outline.vue?vue&type=script&lang=js"
export * from "./outline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports